import { createContext, ReactNode, useContext } from "react";

import { ChartVariant } from "./utils";

/**
 * Ambient design-system brand for every chart rendered beneath the provider.
 * Charts read this as the default for their `variant` prop, so an explicit
 * `variant` on an individual chart always wins. Defaults to `"hub"`.
 */
const ChartVariantContext = createContext<ChartVariant>("hub");

interface ChartVariantProviderProps {
  value: ChartVariant;
  children: ReactNode;
}

/**
 * Sets the brand variant for all charts in a subtree. Wrap a role's route tree
 * (e.g. Asset Manager / Development Manager → `"seed"`) so its charts pick up
 * Figtree + rounded styling automatically, without touching each call site.
 */
export const ChartVariantProvider = ({ value, children }: ChartVariantProviderProps): JSX.Element => (
  <ChartVariantContext.Provider value={value}>{children}</ChartVariantContext.Provider>
);

/** Returns the brand variant from the nearest {@link ChartVariantProvider} (defaults to `"hub"`). */
export const useChartVariant = (): ChartVariant => useContext(ChartVariantContext);
